export default __webpack_public_path__ + "static/media/4_Intro.92459663.mp4";